import
  React, {
  useContext,
  useEffect,
  useState
}	from 'react';

import {
  useHistory,
  useLocation
} from 'react-router';

import {
  HContainer,
  HContainerV,
  Image,
  JourneyProvider,
  Text,
  VContainerH,
  VFillContainer,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  ErrorKeys,
  Icons,
  PaymentOptions
} from '../../../../constants';

import {
  withScreenViewTagging
} from 'hocs';

import {
  createGrandTotal,
  extractDays,
  formatDate,
  getStorageWithExpiry,
  isEqual,
  isOfferIdEligible
} from 'helpers';

import {
  Modal,
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  HandleRender
} from 'hocs';

import {
  CheckoutProvider
} from '../providers';

import {
  ConfirmationForm,
  PaymentGatewayForm,
  SecureCheckout
} from '../components';

import {
  AppContext
} from 'context';

export const VoucherAdvanceSummaryUI = () => {

  const history = useHistory();
  const location = useLocation();
  const { config } = useContext(AppContext);

  const [ state, setState ] = useState({
    checkoutLoading: false,
    checkoutError: null,
    paymentDetails: null,
    showAdvanceConfirmation: false,
    offerId: null,
    eligibilityRequestId: null
  });

  const { category, product, maskedMsisdn, eligibility, paymentType, termDuration, vendorName } = location.state;

  VoucherAdvanceSummaryUI.tagViewData = {
    event_name:'page_view,cart_view',
    journey_step:'cbu: connectu: voucher advance: purchase summary',
    journey_name: 'cbu: connectu: voucher advance',
    journey_type : 'transaction',
    product_category: category,
    product_id: [ product?.name ],
    product_quantity:'1',
    product_price: product?.normal?.currency,
    page_section: 'voucher advance',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_type: 'consumer',
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
  };

  useEffect(() => {

    if (!product || !maskedMsisdn || !paymentType || !termDuration) {
      history.replace('/voucher-advance');
      return;
    }

  }, []);

  const calculateDate = (dayString) => {

    const date = new Date();
    let dateString = date.toDateString();

    if (isEqual(dayString, 'none')) {

      return formatDate(dateString);
    }

    const days = extractDays(dayString);
    return formatDate(dateString, days);
  };

  const onProceedClick = async () => {

    setState(prevState => ({
      ...prevState,
      checkoutLoading: true
    }));

    const voucherDetails = {
      category: category,
      product: product,
      paymentType: paymentType,
      termDuration: termDuration,
      vendorName: vendorName
    };

    JourneyProvider.set('Vouchers', { voucherDetails: voucherDetails });

    const optionId = product?.terms?.duration?.find(term => isEqual(term?.valueType, 'option_id'))?.typeId;
    const termId = product?.terms?.duration?.find(term => isEqual(term?.valueType, termDuration))?.typeId;

    const response = await CheckoutProvider.checkoutVoucherOrder(
      product.id,
      paymentType,
      `${product?.purchaseType?.option_id}|${product?.purchaseType?.[paymentType]}`,
      termDuration,
      `${optionId}|${termId}`,
      state.offerId,
      state.eligibilityRequestId
    );

    if (!response?.ok || !response?.result) {

      setState(prevState => ({
        ...prevState,
        checkoutError: true
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      paymentDetails: response.result.paymentDetails
    }));
  };

  const Header = () => {

    return (

      <VContainerH
        width={'100%'}>

        <Image
          height={'80px'}
          width={'80px'}
          src={Icons.CarerHi}/>

        <Text
          lineHeight={'24px'}
          fontSize={'18px'}>

          {`${vendorName} voucher`}
        </Text>

        <HContainer
          margin={'8px 0'}/>

        <Text
          lineHeight={'39px'}
          fontSize={'26px'}
          fontWeight={'bold'}
          textAlign={'center'}>

          { product?.name }
        </Text>

        <Text
          lineHeight={'24px'}
          fontSize={'16px'}>

          for { maskedMsisdn }
        </Text>

        <HContainerV
          width={'100%'}
          justifyContent={'space-between'}
          margin={'16px 0'}>

          <Text
            fontSize={'16px'}>

            Total:
          </Text>

          <Text
            lineHeight={'39px'}
            fontSize={'20px'}
            fontWeight={'bold'}>

            {createGrandTotal(product?.retailPrice, product?.normal?.currency, paymentType)}
          </Text>
        </HContainerV>
      </VContainerH>
    );
  };

  const Summary = () => {

    return (

      <VFillContainer
        padding={'16px 0'}
        boxSizing={'border-box'}
        justifyContent={'space-between'}
        width={'100%'}
        maxHeight={'125px'}
        borderTop={`0.6px solid ${CustomColors.Grey5}`}
        borderBottom={`0.6px solid ${CustomColors.Grey5}`}>

        <Text
          lineHeight={'24px'}
          fontSize={'18px'}
          fontWeight={'bold'}>

          Checkout summary
        </Text>

        <HContainer
          width={'100%'}
          justifyContent={'space-between'}>

          <Text
            lineHeight={'24px'}>

            Payment method:
          </Text>

          <Text
            lineHeight={'24px'}>

            { PaymentOptions?.[paymentType].label }
          </Text>
        </HContainer>

        <HContainer
          width={'100%'}
          justifyContent={'space-between'}>

          <Text
            lineHeight={'24px'}>

            Payment date:
          </Text>

          <Text
            lineHeight={'24px'}>

            { calculateDate(termDuration) }
          </Text>
        </HContainer>
      </VFillContainer>
    );
  };

  const Footer = () => {

    return (

      <VContainerH
        width={'100%'}>

        <SecureCheckout/>

        <PrimaryButton
          text={'Proceed'}
          isEnabled={!state.checkoutLoading}
          showSpinner={state.checkoutLoading}
          margin={'24px 0 0'}
          onClick={() => {

            if (paymentType !== 'Advance') {

              onProceedClick();
              return;
            }

            const id = product?.terms?.duration?.find?.(term => isEqual(term?.valueType, termDuration))?.offerId;

            if (!isOfferIdEligible(id, eligibility) || !eligibility?.eligibilityRequestId) {

              setState(prevState => ({
                ...prevState,
                checkoutError: true
              }));

              return;
            }

            setState(prevState => ({
              ...prevState,
              offerId: id,
              eligibilityRequestId: eligibility?.eligibilityRequestId,
              showAdvanceConfirmation: true
            }));

          }}/>

        <SecondaryButton
          isEnabled={!state.checkoutLoading}
          margin={'16px 0 0'}
          border={'2px solid'}
          text={'Cancel'}
          onClick={() => history.goBack()}/>
      </VContainerH>
    );
  };

  const Content = () => {

    return (

      <HandleRender
        isLoading={false}
        isError={state.checkoutError}
        error={{
          type: ErrorKeys.TECHNICAL
        }}>

        { state.showAdvanceConfirmation &&

          <Modal
            backgroundColor={CustomColors.White}>

            <ConfirmationForm
              title={config?.voucherAdvanceConfig?.confirmOrderTitle}
              description={config?.voucherAdvanceConfig?.confirmOrderDescription}
              pageName={'cbu: connectu: voucher advance: purchase confirmation'}
              showLegalSection={false}
              tagViewData={{
                event_name: 'page_view',
                page_section: 'voucher advance'
              }}
              onPrimaryClick={onProceedClick}
              isPrimaryEnabled={!state.checkoutLoading}
              isPrimaryLoading={state.checkoutLoading}
              isSecondaryEnabled={!state.checkoutLoading}
              onSecondaryClick={() => {

                setState(prevState => ({
                  ...prevState,
                  showAdvanceConfirmation: false
                }));
              }}/>

          </Modal>
        }

        <VFillContainerVH
          padding={'24px'}>

          <Header/>

          <Summary/>

          <Footer/>

          <PaymentGatewayForm
            paymentDetails={state.paymentDetails}/>

        </VFillContainerVH>
      </HandleRender>
    );
  };

  return (

    <Content/>
  );
};

VoucherAdvanceSummaryUI.pageName = 'cbu: connectu: voucher advance: purchase summary';

export const VoucherAdvanceSummary = withScreenViewTagging(VoucherAdvanceSummaryUI);